function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgServiceProduktFuerAlleMonteure = function SvgServiceProduktFuerAlleMonteure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.48 84.9"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.92 83.58h32.64V72.06c0-.02.01-.05.04-.06 13.31-6.18 22.56-19.63 22.56-35.27S69.78 7.46 56.33 1.33c-.04-.02-.08.01-.08.05v35.29s-.03.06-.06.06h-31.9s-.06-.03-.06-.06V1.38s-.04-.07-.08-.05C10.7 7.46 1.33 20.99 1.33 36.74s9.25 29.09 22.56 35.27c.02.01.04.03.04.06v11.52Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: "2.66px"
    }
  }));
};
export default SvgServiceProduktFuerAlleMonteure;